/**
 * 新闻模块静态数据源
 * 新闻列表与详情页均从此处读取，不依赖后端接口
 */

// 新闻分类
export const newsCategories = [
  {id: 1, name: '公司新闻'},
  {id: 2, name: '行业动态'},
  {id: 3, name: '技术洞察'}
];

/**
 * 新闻列表
 * 新增新闻：在此数组中追加一条，_id 需唯一（如 news7），
 * 列表页 /news 与详情页 /news/:id 自动生效
 */
export const newsItems = [
  {
    _id: 'news9',
    title: '从花箱上桥到系统落地：景天下城市桥体智慧管养复康的工程实践——天津复康路立交桥项目纪实',
    content: `
      <p>很多人看到桥体绿化，第一印象，就是护栏外侧一排排整齐的花箱。</p>
      <p>但一座大型城市立交桥的桥体绿化，从来不是把花箱批量采购、吊装上架这么简单。</p>
      <p>普通地面绿化，可以开挖地面，工作面开阔，白天可以连续施工；而复康路立交桥是正在通行的城市快速交通枢纽，桥梁本体不能随意破坏、荷载有严格约束、受天津本地规范限制、施工只能压缩在有限的交通窗口期。</p>
      <p>从北京木樨地桥、东四环积累下来的项目经验告诉我们：花箱就位，仅仅是工程的一小部分。真正的难点藏在花箱背后：构件锚固、管线排布、水电通信、分区设计、排水防护、现场施工组织。复康桥的施工全过程，就是在多重现实约束下，完成一整套种植、给排水与物联网软硬件系统相结合的落地实践。</p>
      <img src="${require('@/assets/images/news/fukang2/cover.jpeg')}" alt="北京木樨地桥桥体绿化实景">
      <p class="caption">北京木樨地桥</p>
      <h2>花箱上桥，首先要解决的不是"怎么装"，而是"能不能安全装"</h2>
      <p>地面绿化，苗木到场、挖坑、放苗、回填基质即可完成栽植。而桥梁花箱属于独立外挂附属体系，施工不能简单对桥体直接开孔作业，需综合考量桥体材质、原有结构承重条件、内部钢筋及预应力管线分布、开孔孔径与构件厚度匹配、防腐、防水等多重因素。所有参数不得仅凭图纸理论取值，每一项均应开展现场实地实测，依据实测数据再编制专项施工方案，确定开孔、锚固及安装工艺，规避对桥梁主体结构造成损伤。</p>
      <img src="${require('@/assets/images/news/fukang2/muxidi.jpeg')}" alt="复康桥桥面外挂花箱实景">
      <p>天津市早期桥梁花箱多为护栏内挂形式，存在行车安全隐患。结合过往实际应用情况，依据本市现行管理要求，桥梁净空4.5米以下禁止布设花箱。复康路立交桥所有花箱统一布置在护栏外侧，不采用简易挂扣式结构，选用304不锈钢定制花箱托架及抱箍体系；托架采用化学锚栓与桥梁地袱可靠连接，连接节点按照抗拔、抗剪双重验算进行控制，从结构层面把"安全装"作为前置条件。</p>
      <p class="caption">外挂式花箱</p>
      <h2>桥上没有土层，灌溉系统首先要解决"管路怎么走"</h2>
      <p>地面绿化可以开挖沟槽埋置管线；桥上没有可开挖土层，桥梁伸缩缝形变、紫外线暴晒、高低压差，都是灌溉系统必须面对的现实难题。</p>
      <p>复康路立交桥所有给排水管路、滴灌管路，全部收纳于和地袱同色的封闭式金属桥架内部，管线不裸露在外，规避紫外线加速老化，同时不侵入行车界限，保持外观整洁。管线跨越桥梁伸缩缝位置，避免因桥梁形变产生的拉扯应力，造成管路撕裂、破损。</p>
      <p>整座桥主线、匝道存在明显高程差，会带来供水水压不均衡问题。项目依据桥体结构，划分多个灌溉分区，每个区域分区配置电磁阀，配套压力补偿滴灌。解决高处供水压力不足、低处水压过高冲翻基质的问题。</p>
      <img src="${require('@/assets/images/news/fukang2/pipeline.jpeg')}" alt="桥架内灌溉管路与阀控细节">
      <h2>没有水井、没有外接网口，水、电、通信必须同步设计</h2>
      <p>不少人会产生疑问：高架桥上，智慧管养设备的水从哪来、电从哪来、数据怎么传回系统？复康桥的解决方案，是绿化与管养系统硬件同步设计、同步施工，而不是花箱装好之后再外挂一堆设备线缆。</p>
      <p>供水就近对接桥梁既有市政供水点位，分区设置水表，主管道前置减压，再分配至各个灌溉分区。</p>
      <p>供电方面，采用太阳能供电，控制柜、电磁阀、各类感知终端全部采用桥架内低压线缆集中铺设，强电弱电分槽布设；所有接线点位做防水密封处理，适配露天雨雪、昼夜温差大的桥上环境。</p>
      <img src="${require('@/assets/images/news/fukang2/solar.jpeg')}" alt="桥上太阳能供电系统">
      <p>通信层面，土壤墒情、管网压力、流量传感器的数据需要回传景天下智圃AI管养系统。有线通信线缆跟随桥架同步铺设；针对部分布线难度高的匝道点位，采用工业级无线物联网终端作为补充，保障各个分区设备稳定上传数据，实现远程监测、远程启停灌溉。</p>
      <p class="caption">太阳能板与定位系统</p>
      <h2>同一座桥，也不能用一套方案从头套到尾</h2>
      <p>复康路立交桥包含主线、多条支线、环线、上跨铁路段、隔音屏、桥肩等多种载体，不同区段风速、光照、边界约束完全不同，项目没有采用千篇一律的标准化布置，而是做差异化分区设计。</p>
      <p>主线护栏区：车流量大、风力强，采用标准化连续花箱布置，优先选用抗风低维护植物。</p>
      <p>匝道转弯区：光照角度多变，独立划分灌溉压力分区，控制植株高度，保障驾驶员通行视野。</p>
      <p>桥肩局部点位：结合市政要求，4.5m以下不布置花箱，其余位置结合载体实际条件选用适配容器，不强行套用护栏花箱模式。</p>
      <p>分区不只是景观布局，灌溉策略、设备配置、后期运维要求，都会跟着分区同步调整。</p>
      <img src="${require('@/assets/images/news/fukang2/mainroute.jpeg')}" alt="主线标准化连续花箱布置">
      <p class="caption">主线：标准化连续花箱</p>
      <img src="${require('@/assets/images/news/fukang2/other.jpeg')}" alt="其他位置分区布置">
      <p class="caption">其他位置：分区布置</p>
      <h2>安全不是最后一道工序，而是贯穿施工全过程的底线</h2>
      <p>桥体绿化的安全分为两大维度：桥梁结构安全和社会公共通行安全。</p>
      <p>前期完成桥梁结构荷载复核，花箱、托架、含水基质全部计入附加荷载；锚固螺栓、托架全部完成抗拔验算，花箱配套防脱限位构造，抵御强风，杜绝高空坠物风险。</p>
      <p>施工阶段，桥上属于正在运营的快速路，绝大部分吊装、托架锚固、管线对接作业，只能安排在夜间交通导改窗口期开展。作业人员全套高空安全防护，所有构件、工具落实防坠措施，严防物料碎屑掉落桥下通行路面。</p>
      <p>同时在设计阶段就前置运维安全考量：金属构件选用304不锈钢等高防腐等级材料，适配桥梁使用年限；依靠管养系统硬件实现远程状态监测，尽可能减少后续人员频繁上桥作业的安全压力。</p>
      <img src="${require('@/assets/images/news/fukang2/safety.jpeg')}" alt="夜间施工班前教育">
      <h2>物理安装只是起点：数字化集成才是桥体AI管养的核心价值</h2>
      <p>普通绿化，是在空地上营建景观；桥体绿化，则是在已经投入运行的交通构筑物之上，叠加一整套种植、给排水、物联网智慧系统。面对匝道多、作业难的桥体工况，仅仅完成硬件铺设远远不够，还需要数字化平台统筹所有设备，利用AI管养破解传统养护的现实局限。</p>
      <img src="${require('@/assets/images/news/fukang2/pumpstation.jpeg')}" alt="景天下智能综合泵站">
      <p>硬件全部安装调试完毕，并不是施工的终点。整套灌溉、传感终端，全部接入景天下智圃AI管养系统。各个分区土壤墒情、管网压力流量数据实时回传，结合气象条件自动调整灌溉策略，设备异常可以远程预警。从北京木樨地桥、东四环项目沉淀的系统能力，在复康桥项目完成进一步迭代落地。</p>
      <p class="caption">景天下智能综合泵站</p>
      <p>花箱只是看得见的表象。真正决定一座桥体绿化能不能长期安全运行，恰恰是花箱背后看不见的工程细节。竣工只是建设的句号，而长期的养护运营，才是真正考验的开始。</p>
    `,
    category: 1,
    cover: require('@/assets/images/news/fukang2/cover.jpeg'),
    editTime: '2026-08-27'
  },
  {
    _id: 'news8',
    title: '从桥体绿化到AI管养：景天下复康路立交桥的天津实践——景天下复康路立交桥项目纪实',
    content: `
      <h2>一座城市立交桥，为什么需要绿化？</h2>
      <p>当桥体绿化从"增绿"走向常态化，它面对的就不再只是植物怎么种、花箱怎么摆，而是安全、景观、灌溉、施工和长期养护如何协同。从北京木樨地桥、东四环等项目，到天津复康路立交桥，景天下正在把桥体绿化实践进一步延伸到AI管养。</p>
      <p>复康桥，是一次新的探索，也是景天下对"桥体绿化如何长期、安全、精准地养起来"的又一次实践。</p>
      <p>复康路立交桥位于天津城市快速路重要节点，桥区东西向长度约1600米、南北向长度约750米。按照2026年2月前期方案口径，花箱布置覆盖主线、4条支线、4条环线、南北向桥段以及上跨铁路、隔音屏、罩棚、防抛网和上桥口等特殊位置，初步设计总长度约12.35公里。</p>
      <img src="${require('@/assets/images/news/fukang/cover.jpeg')}" alt="复康路立交桥全景">
      <h2>一座桥，为什么需要AI管养？</h2>
      <p>过去，人们看到一座桥体上的花箱，首先看到的是景观。但对于养护人员来说，桥上的每一株植物背后，实际上是一套复杂的管理问题。</p>
      <p>这些问题，在普通地面绿地中或许可以通过人工巡查和水车作业等解决；但对于桥梁、立交桥等特殊城市空间，答案并没有那么简单。桥体养护天然受到交通环境制约。人员上桥存在安全风险，水车作业占用道路资源，夜间施工窗口有限；遇到重大活动或特殊交通管控时，养护人员还可能无法正常上桥，而植物的生长并不会因此停止。这也是为什么，桥体绿化真正需要解决的，不只是"种上去"，而是"长期养得好"。</p>
      <p>AI管养的意义，正在于让原本依赖人工经验的浇灌和管理，逐步转向可感知、可决策、可追踪、可自我优化方式的智慧管养。同时，AI管养通过减少人工上桥、降低水车作业频次、精准控制灌溉水量，显著降低长期养护的人力成本、车辆成本和资源消耗，让桥体绿化在保持景观效果的同时，具备更低的综合运营成本。</p>
      <h2>从北京开始，景天下一直在回答这个问题</h2>
      <p>北京，是景天下开展桥体AI管养实践的重要起点。在木樨地桥、东四环等项目中，景天下持续探索桥体绿化与智慧灌溉的结合。</p>
      <p>从土壤温湿度监测，到压力、流量等数据采集；从自动灌溉，到远程控制；从单一设备控制，到逐步形成感知、控制和管理相结合的系统，项目实践让一个问题越来越清晰：</p>
      <p>真正的AI管养，需要知道植物所处的环境，需要知道水有没有真正浇到，需要知道设备是否正常运行，也需要把一次次运行产生的数据沉淀下来，为后续养护策略提供依据。</p>
      <p>在景天下的实践中，桥体AI管养也因此逐步从"自动灌溉"向"数据驱动的养护管理"演进。现有项目已经涉及土壤温湿度、压力、流量等监测，并进一步探索雨量、水肥一体化等的智慧管养能力。这些技术的叠加，不仅提升了养护精准度，也在持续压缩传统养护模式下难以避免的冗余成本。</p>
      <img src="${require('@/assets/images/news/fukang/muxidi.jpeg')}" alt="北京木樨地桥立体绿化实景">
      <p class="caption">北京木樨地桥立体绿化实景</p>
      <img src="${require('@/assets/images/news/fukang/east4th.jpeg')}" alt="北京四环桥立体绿化实景">
      <p class="caption">北京四环桥立体绿化实景</p>
      <p>当北京经验来到天津，面对的是另一座桥、另一套条件的复康路立交桥，也是景天下在天津的一次新的实践。</p>
      <p>与北京已有项目相比，复康桥面临着不同的城市建设条件和桥体环境。其中，一个非常明确的要求就是：桥体4.5米以下区域严禁布设花箱。这意味着，北京已经形成的部分桥体绿化经验，并不能简单复制到天津。</p>
      <p>花箱应该放在哪里？怎样形成较好的景观效果？怎样保证车辆通行安全？怎样让后期灌溉和养护能够真正实施？这些问题，都必须在项目设计阶段重新回答。</p>
      <p>因此，复康桥项目从一开始就不是简单地"把北京的方案搬到天津"，而是根据天津当地规范、桥体条件和交通环境，对花箱布置、植物配置、固定方式、给排水及智慧控制系统进行重新设计。</p>
      <p>复康路立交桥包含主线、支线、环线及南北方向多个桥体空间，整体花箱布置规模较大；项目同时针对上桥点位、花箱管道布设等进行了专项设计。</p>
      <p>这正是一个成熟项目经验真正有价值的地方：不是复制上一座桥，而是把经过验证的方法重新适配一座新的城市和新的场景。</p>
      <img src="${require('@/assets/images/news/fukang/overview.jpeg')}" alt="复康路立交桥花箱布置实景">
      <h2>对桥体来说，"AI管养"是一种刚需</h2>
      <p>桥体AI管养并不是为了让一个普通的灌溉系统看起来更"科技"。它首先来自现实需求。</p>
      <p>一方面，是安全。传统水车浇灌需要人员进入桥面作业。对于车流密集的桥体和环线道路而言，人员与车辆共同作业本身就存在风险。景天下此前对桥体养护的调研也显示，桥面作业窗口短、交通组织严格，人工上桥存在较高安全压力。</p>
      <p>另一方面，是养护效率和成本。传统水车浇灌不仅需要车辆和人员，而且受交通、天气和作业时间影响较大，车辆油耗、人工工时、水资源浪费等隐性成本容易被忽视。对于规模化桥体绿化而言，如何减少不必要的人工上桥、提高灌溉效率，本身就是一个现实问题。AI管养通过自动化灌溉、远程监控和按需供水，能够有效减少人工巡检和水车作业频次，降低人力、车辆、油耗及水资源消耗，在保障养护质量的同时实现更低成本、更高效率的长期运营。</p>
      <p>更重要的是，桥体绿化需要的是保持持续美观的养护效果，而不是一次性景观建设。花箱安装完成，只是项目开始。植物能不能稳定生长？水能不能精准送达？设备出现故障能不能及时发现？这些决定着一座桥的绿化能不能真正长期保持效果。</p>
      <p>所以，从景观建设走向AI管养，并不是增加几个传感器、安装一套软件那么简单。它实际上是在重新建立一套"感知—决策—控制—反馈—优化"的养护闭环。这个闭环一旦形成，养护动作就会从"凭经验、靠人力"转向"按数据、靠系统"，从而在长期运行中持续摊薄管理成本。</p>
      <img src="${require('@/assets/images/news/fukang/backend.jpeg')}" alt="景天下后台管养数据">
      <p class="caption">景天下后台管养数据</p>
      <h2>复康桥正在成为这套能力的一次新实践</h2>
      <p>在复康桥项目中，智慧控制系统将土壤墒情监测、物联网云平台、移动端控制、阀控及灌溉系统结合起来，根据植物生长和土壤环境状况，为灌溉提供更加精准的控制依据。项目设计同时配置了水肥一体化、加压泵站、滴灌及排水等系统。</p>
      <p>花箱不再只是一个承载植物的容器。它正在成为城市桥体AI管养系统中的一个节点。而一座桥，也不再只是"摆满花箱之后变漂亮"。它需要从设计、施工开始，就考虑后续的灌溉、监测、维护和管理。这也是景天下理解的桥体AI管养：让景观建设与长期养护从一开始就被放进同一个系统里。</p>
      <p>水肥一体化与精准灌溉的结合，不仅提升了植物生长质量，也减少了水肥浪费，从资源利用角度进一步降低了长期养护成本。这使得AI管养不只是技术升级，更是一种可持续的成本控制方式。</p>
      <p>从"种得上"到"养得好"，是桥体绿化真正的挑战。</p>
      <img src="${require('@/assets/images/news/fukang/irrigation.jpeg')}" alt="复康桥水肥一体化与精准灌溉">
      <h2>对于一座桥来说，竣工并不是故事的结束</h2>
      <p>真正长期的考验，来自之后每一个季节：春天如何恢复生长？夏季高温如何保证供水？雨季如何避免过度灌溉？冬季如何做好管线和植物保护？设备发生异常时，能不能及时发现？养护人员能不能少上一次桥？</p>
      <p>这些问题，才决定一座桥的绿化究竟能不能真正"活下来、保持住、运行好"。</p>
      <p>从北京到天津，景天下正在把桥体绿化从单一的景观建设，进一步推向景观效果可持续长期运营的AI管养。复康桥是其中的一次实践，也是下一阶段继续探索的起点。在这一过程中，AI管养所体现出的低成本、低风险、景观效果可持续优势，正成为桥体绿化从"一次建设"走向"长期运营"的关键支撑。</p>
      <img src="${require('@/assets/images/news/fukang/completed.jpeg')}" alt="复康路立交桥绿化完工实景">
    `,
    category: 1,
    cover: require('@/assets/images/news/fukang/cover.jpeg'),
    editTime: '2026-08-26'
  },
  {
    _id: 'news7',
    title: '北京发布《城镇绿地智慧养护系统建设技术规范》，景天下参与主要起草，智慧管养进入标准化建设阶段',
    content: `
      <p><strong>这项北京智慧养护地方标准自2025年10月1日正式实施，至今已实施近11个月。近一年的实施，意味着北京城镇绿地智慧养护已经从"有没有标准"进入"标准如何落地"的阶段。景天下生态环境科技有限公司作为该标准的第一起草单位，创始人李艳作为第一主要起草人，正带领公司把标准要求对应到北京木樨地桥、东四环桥体及环线道路、天津复康路桥等实际项目中。</strong></p>
      <h2>北京城镇绿地智慧养护进入标准化建设阶段</h2>
      <p>2025年10月1日，北京市地方标准DB11/T 2467—2025《城镇绿地智慧养护系统建设技术规范》正式实施。截至2026年8月25日，该标准已实施近11个月。</p>
      <img src="${require('@/assets/images/news/standard/cover.png')}" alt="《城镇绿地智慧养护系统建设技术规范》">
      <p>作为北京市城镇绿地智慧养护领域的重要地方标准，这近一年的实施，使北京城市绿地智慧养护从标准制定进入了标准落地和项目实践阶段：智慧养护系统建设开始有了统一的技术依据，智慧灌溉、感知监测、数据采集、养护作业管理以及系统运维等，也逐步从单一项目的技术探索，进入系统化建设。</p>
      <p>该标准由北京市园林绿化局提出并归口、组织实施，于2025年6月24日发布，2025年10月1日起实施，适用于北京地区城镇绿地智慧养护系统建设。标准规定了城镇绿地智慧养护系统建设的总体要求、系统规划、系统设计、系统实施和系统运维等技术内容。</p>
      <p>该标准除了景天下生态环境科技有限公司作为该标准主起草单位外，标准起草单位还包括北京市园林绿化大数据中心、北京市园林绿化集团有限公司、北京市园林绿化科学研究院等单位。</p>
      <img src="${require('@/assets/images/news/standard/drafting.png')}" alt="标准起草单位名单">
      <h2>实施近11个月，北京智慧养护从"标准制定"走向"标准落地"</h2>
      <p>在过去很长一段时间里，城市绿地智慧化建设更多以具体项目为单位开展，不同项目根据自身需求配置传感器、灌溉设备、通信系统和管理平台。该标准的实施，首先解决的是：智慧养护系统"怎么建"的问题。</p>
      <p>标准将城镇绿地智慧养护系统划分为基础设施层、数据层、业务应用层和展示层，并分别对系统规划、系统设计、系统实施和系统运维提出技术要求。</p>
      <p>其中，基础设施层涉及气象站、土壤监测设备、智能水表、灌溉设备、病虫害监测设备、绿地巡视记录仪、视频监控等感知和控制设施；数据层则涉及植物基础数据、养护基础数据、感知数据、设备运行状态数据和养护作业数据等。在业务应用层，标准明确提出绿地分区管理、养护作业管理、智慧灌溉、养护技术档案管理等基础应用。</p>
      <img src="${require('@/assets/images/news/standard/architecture.jpeg')}" alt="城镇绿地智慧养护系统架构">
      <p>这使"智慧养护"不再只是一个设备概念，而是开始形成从感知、数据、业务应用到养护管理的系统建设框架。</p>
      <h2>标准把"智慧灌溉"纳入城镇绿地智慧养护体系</h2>
      <p>对于城市绿地而言，灌溉是日常养护中最直接、最基础的工作之一。标准明确提出，智慧灌溉区域应配置土壤温湿度传感器；系统宜根据采集的土壤墒情、气象数据，并结合绿地土壤类型和植物种类，采用智慧灌溉数据模型算法给出灌溉建议，或由系统智能控制实现植物自动灌溉。</p>
      <p>同时，智慧灌溉系统应具备人工远程灌溉、智慧灌溉及灌溉用水统计功能。</p>
      <p>标准对养护作业管理也提出了明确要求：植物养护和绿地管理应实施全流程管理，形成任务产生、任务派发、任务处置的业务流程；设备告警产生的任务可以由系统自动派发，处置完成后提交管理人员验收。</p>
      <p>换句话说，标准关注的不只是"能不能自动浇水"，还包括：数据能不能采集；设备能不能感知；灌溉能不能控制；异常能不能发现；养护任务能不能形成闭环；养护过程能不能留下数据。</p>
      <p>这也是智慧管养与传统自动灌溉之间的重要区别。</p>
      <h2>AI开始进入智慧养护的技术体系</h2>
      <p>《城镇绿地智慧养护系统建设技术规范》对"城镇绿地智慧养护"的定义，本身就包含了物联网、大数据、人工智能等信息技术。</p>
      <p>标准将城镇绿地智慧养护定义为：运用物联网、大数据、人工智能等信息技术，对城镇绿地养护的要素、事件进行实时监测和智能分析，通过动态交互、科学决策提升城镇绿地养护效率和质量的活动。</p>
      <p>在系统应用层面，标准还提出，可以通过数据分析、人工智能算法模型，对支撑数据和业务数据进行分析，输出养护决策建议，并通过机器学习持续优化算法。</p>
      <p>因此，从标准层面看，AI管养、AI园林并不是脱离园林业务单独增加一个"AI功能"，而是建立在感知数据、植物数据、养护数据和业务数据基础上的进一步应用。</p>
      <img src="${require('@/assets/images/news/standard/ai.jpeg')}" alt="AI智慧养护技术体系">
      <p>这也意味着，未来智慧养护系统的价值，不只是"把人从现场操作中解放出来"，还包括利用持续积累的数据辅助养护管理和决策。</p>
      <h2>为什么桥体、环线和道路绿化成为智慧管养的重要场景？</h2>
      <p>标准实施近一年，智慧养护如何真正进入城市绿地实际场景，是行业下一阶段需要解决的问题。</p>
      <p>在北京，桥体、环线和道路绿化是智慧管养需求较为集中的场景。与普通公园绿地相比，桥体和环线道路绿化具有明显的特殊性：绿化空间处于交通环境中，人工上桥作业受到交通和安全条件限制；道路绿化距离长、点位分散；灌溉管线多，设备运行和故障排查需要较多现场人员。</p>
      <p>北京四环路"月季花环"就是典型的环线绿化场景。相关项目资料显示，四环路月季景观带全长约65.3公里，栽植月季约71.3万株，新建灌溉管道约50万米。随着桥体、环线和道路绿化规模不断扩大，传统人工巡查和水车浇灌方式在人员、安全、交通组织、用水和设备管理方面面临越来越大的压力。</p>
      <img src="${require('@/assets/images/news/standard/ringroad.jpeg')}" alt="北京四环路月季景观带">
      <p>因此，桥体智慧绿化、道路智慧养护、智慧灌溉和AI管养，正在成为北京城市绿地数字化建设的重要应用方向。</p>
      <h2>景天下：从标准起草到项目实践</h2>
      <p>景天下参与DB11/T 2467—2025标准制定，与企业长期参与城市绿地智慧养护项目的实践直接相关。</p>
      <p>标准明确的系统架构、智慧灌溉、感知监测、养护作业管理等内容，在景天下近年来的桥体和道路项目中都有对应的实践。</p>
      <h3>木樨地桥：北京桥体智慧灌溉实践</h3>
      <p>在北京木樨地桥项目中，景天下围绕桥体花箱绿化建设给排水及智慧灌溉系统。项目采用市电供电与4G通讯的控制系统，通过4G无线通信采集土壤湿度信息，并结合灌溉策略控制水泵和电磁阀，实现智慧灌溉、远程监控等功能。</p>
      <p>随着项目实践不断推进，景天下进一步将土壤温湿度、流量、压力等数据纳入智慧灌溉体系，通过不同区域的分区控制和运行数据，对灌溉策略进行调整。</p>
      <p>木樨地桥的实践所面对的，是桥体智慧绿化最直接的问题：什么时候浇、浇多少、有没有真正浇到、设备是否正常运行。</p>
      <p>这些具体问题，也成为景天下参与智慧养护标准制定的重要实践基础。</p>
      <img src="${require('@/assets/images/news/standard/muxidi.jpeg')}" alt="木樨地桥项目">
      <h3>东四环：从桥体向环线道路延伸</h3>
      <p>在北京东四环道路部分标段绿化项目中，景天下进一步将智慧灌溉应用延伸到城市环线道路场景。</p>
      <p>项目采用有线控制+4G数据传输方案，对道路绿化灌溉进行控制和数据采集。与桥体项目相比，东四环道路绿化具有更长的线路和更复杂的现场条件，对控制、通信、供电、管线和设备配置提出了不同要求。</p>
      <p>目前，景天下正在通过木樨地桥、东四环等项目的比较和实践，不断优化不同桥体、道路和环线场景下的智慧灌溉方案。现有项目资料中，木樨地桥、东四环和天津复康桥已经形成了无线+市电、有线+市电、无线+太阳能三种不同技术路线的项目实践。</p>
      <img src="${require('@/assets/images/news/standard/east4th.jpeg')}" alt="东四环道路绿化项目">
      <h2>天津复康路立交桥：智慧管养继续向桥体环线场景延伸</h2>
      <p>在天津复康路立交桥项目中，景天下进一步开展桥体花箱、给排水和智能化系统建设。</p>
      <p>项目方案结合桥体、支线和环线实际条件，对花箱、供水、灌溉和智能化进行整体设计。项目花箱布置总长度约12350米，并采用智能滴灌系统。</p>
      <p>与北京木樨地桥、东四环相比，天津复康桥进一步采用了无线通信、太阳能供电、土壤温湿度、压力、流量、雨量以及水肥一体化泵站等技术组合，形成了不同于北京项目的桥体智慧灌溉方案。现有项目资料显示，天津复康桥项目目前已完成竣工。</p>
      <p>从北京木樨地桥、东四环，到天津复康路立交桥，景天下正在把智慧养护技术从单一桥体项目进一步延伸到桥体、环线、道路绿化等更大范围的城市绿地场景。</p>
      <img src="${require('@/assets/images/news/standard/tianjin.jpeg')}" alt="天津复康路立交桥项目">
      <h2>标准的意义，不只是"有了一份文件"</h2>
      <p>标准实施近11个月后，其意义正在逐渐从"制定了一套技术要求"转向"为实际建设提供共同依据"。</p>
      <p>对于政府和业主单位而言，标准提供了城镇绿地智慧养护系统建设的基本技术框架，可以据此理解系统应该建设哪些基础设施、采集哪些数据、配置哪些业务应用，以及后续如何实施和运维。</p>
      <p>对于养护企业而言，智慧养护不再只是增加一套设备或者一个平台，而是可以进一步进入养护计划、灌溉管理、巡检、任务处置、设备告警、养护档案和成果监管等实际业务。</p>
      <p>对于技术企业而言，标准也提出了更加明确的技术方向：感知设施要进入实际养护；数据要与业务结合；智慧灌溉要能够形成数据支撑；设备告警要能够进入任务处置；AI和算法最终要服务于养护决策。</p>
      <p>这使北京城镇绿地智慧养护逐步从过去的"项目化探索"，进入"标准化建设、项目化落地"的阶段。</p>
      <h2>从北京标准到项目实践，智慧管养进入下一阶段</h2>
      <p>2025年6月24日发布、10月1日起实施的DB11/T 2467—2025，至今已经实施近11个月。近一年的时间，对于一项地方技术标准而言，真正重要的已经不是"标准有没有发布"，而是标准能否进入实际项目，能否解决城市绿地养护中的真实问题。从北京木樨地桥的桥体智慧灌溉，到东四环的道路绿化智慧灌溉，再到天津复康路立交桥正在形成的桥体环线智慧管养实践，景天下正在持续把标准中的智慧养护要求与实际项目结合。</p>
      <p>从北京四环路月季景观带，到城市桥体、环线道路，再到天津复康路立交桥，城市绿地规模不断扩大，养护对象也越来越复杂。</p>
      <p>未来的智慧管养，核心仍然是回到养护本身：让数据真正进入养护，让灌溉更加精准，让异常能够被发现，让养护任务能够闭环，让AI和算法真正服务于植物和绿地的养护管理。</p>
      <p>对于北京而言，DB11/T 2467—2025的实施，标志着城镇绿地智慧养护已经有了更加明确的技术依据。对于景天下而言，从参与标准主要起草，到木樨地桥、东四环等北京项目，再到天津复康路立交桥的实践，正在形成一条从标准制定、项目验证到智慧管养落地的实践路径。</p>
      <p>北京城镇绿地智慧养护，正在从标准走向项目，从项目走向更大范围的应用。</p>
    `,
    category: 1,
    cover: require('@/assets/images/news/standard/cover.png'),
    editTime: '2026-08-25'
  },
  {
    _id: 'news6',
    title: '传统园林的阵痛智慧园林的星辰大海',
    content: `
      <p>机器人在舞台上凌空翻转，嫦娥六号带回月球背面最古老的土壤，AI大模型为我们解答无数好奇与疑问，科技正以前所未有的速度重塑我们的生活，但传统园林养护的困境仍在频频阵痛着行业内的每一个人。</p>
      <h2>传统园林养护的三重困境</h2>
      <p>一是人力成本持续攀升。园林养护是典型的劳动密集型行业，修剪、浇灌、除草、病虫害防治高度依赖人工作业，随着用工成本逐年上涨，传统管养模式的利润空间被不断挤压。</p>
      <p>二是管理粗放、响应滞后。绿地分散在城市各个角落，依靠人工巡检发现问题，往往滞后数天甚至数周，小问题拖成大损耗，救火式管理成为常态。</p>
      <p>三是数据缺失、决策靠经验。浇水凭感觉、施肥凭经验，缺乏对土壤、气象、植物长势的量化感知，水资源浪费与养护不足并存。</p>
      <h2>智慧园林的星辰大海</h2>
      <p>智慧园林以物联网感知为底座，将土壤墒情、气象环境、设备状态实时在线化；以数据平台为大脑，将养护标准、巡检工单、资产台账统一管理；以AI算法为引擎，实现精准灌溉、智能预警与养护决策优化。</p>
      <p>从"人找问题"到"问题找人"，从"经验养护"到"数据养护"，这场变革才刚刚开始。对行业中的每一家企业而言，阵痛是转型的前奏，智慧化是不可逆转的方向。</p>
    `,
    category: 2,
    cover: require('@/assets/images/news/6.jpg'),
    editTime: '2025-12-23'
  },
  {
    _id: 'news5',
    title: '聚焦"百姓园林"，赋能行业未来：景天下智慧花箱亮相第十五届中国风景园林学会年会',
    content: `
      <p>近日，第十五届中国风景园林学会在云南昆明圆满落幕，这场以"百姓园林、乡土风景"为主题的行业盛会，吸引了近1500名专家学者、企业代表及高校师生齐聚一堂，共同探讨风景园林行业如何服务民生、推动高质量发展。</p>
      <h2>智慧花箱成为展区焦点</h2>
      <p>景天下科技携新一代智慧花箱产品亮相年会展区。该产品将物联网感知、精准灌溉与轻量化管理平台融为一体，可实现花卉水分的自动监测与按需补水，大幅降低街头花箱的人工养护频次，让"百姓园林"既有颜值、又有智慧。</p>
      <p>展会现场，智慧花箱的实景演示吸引了众多与会嘉宾驻足。多位学会专家表示，此类低门槛、易部署的智慧化产品，正是园林养护走向普惠化、精细化的关键抓手。</p>
      <h2>聆听行业声音，明确发展方向</h2>
      <p>会议期间，公司团队参加了多场学术论坛与专题交流，围绕城市更新、社区花园、生态修复等热点议题与行业同仁深入探讨。"百姓园林"所倡导的以人为本、共建共享理念，与景天下"让绿色空间更智慧、更有温度"的使命高度契合。</p>
      <p>未来，景天下科技将持续深耕智慧园林领域，以更丰富的产品矩阵与解决方案，助力风景园林行业高质量发展。</p>
    `,
    category: 2,
    cover: require('@/assets/images/news/5.jpg'),
    editTime: '2025-12-16'
  },
  {
    _id: 'news4',
    title: '北京展馆闪耀2025世界林木业大会"花园城市 京彩生活"主题展区科技与自然融合引关注',
    content: `
      <p>2025年11月22日，以"林木绿业 合作共襄——数智赋能林木业高质量发展"为主题的2025年世界林木业大会在广西南宁隆重开幕。大会由广西壮族自治区人民政府主办，国内外行业领袖、专家学者齐聚一堂，共同探讨林业绿色发展与数智融合新路径。北京市园林绿化局受邀参展，精心打造以"花园城市 京彩生活"为主题的北京形象馆，成为大会现场备受瞩目的亮点展区。</p>
      <h2>科技元素点亮北京形象馆</h2>
      <p>北京形象馆以"花园城市"建设成果为主线，集中展示了首都园林绿化在生态修复、生物多样性保护、智慧管养等方面的创新实践。展区内的智慧园林互动沙盘、AI病虫害识别演示等科技体验项目，让参观者直观感受到数智技术为传统园林绿化带来的深刻变化。</p>
      <h2>数智融合成为行业共识</h2>
      <p>大会期间举办的数智赋能主题论坛上，与会嘉宾普遍认为，人工智能、物联网、大数据等新技术正在重塑林木业全产业链，从种质资源保护到森林精准抚育，从城市绿地管养到生态产品价值实现，数字化、智能化已成为行业高质量发展的必由之路。</p>
      <p>作为智慧园林领域的参与者和建设者，景天下科技将持续关注行业前沿动态，以科技力量服务绿色发展。</p>
    `,
    category: 2,
    cover: require('@/assets/images/news/4.jpg'),
    editTime: '2025-12-08'
  },
  {
    _id: 'news3',
    title: '【智慧空间】让空间拥有"智慧"，让生活更有温度',
    content: `
      <p>智慧空间就是将各种技术产品应用于具体的物理空间，从而让冰冷的物理空间变成一种能主动感受人的存在、判别人的活动，并准确提供服务的智能化空间。主要体现在人、空间，以及二者的关系互动，让人感受来自空间主动关怀。</p>
      <h2>智慧空间的三大能力</h2>
      <p><strong>感知能力</strong>：通过传感器网络，空间可以实时感知温湿度、光照、人流、环境质量等要素，像拥有了"五官"，对发生在其中的一切了然于心。</p>
      <p><strong>思考能力</strong>：依托边缘计算与AI算法，空间能够对感知数据进行分析研判——识别人群聚集、预判设备故障、优化能耗策略，形成"空间大脑"。</p>
      <p><strong>服务能力</strong>：基于感知与思考的结果，空间通过灯光、空调、灌溉、信息发布等执行设备主动提供服务，无需人工干预，实现从"人适应空间"到"空间适应人"的转变。</p>
      <h2>从概念走向日常</h2>
      <p>在公园里，智慧步道记录你的运动数据，智慧座椅为手机无线充电；在社区中，智能灌溉让绿地始终保持最佳状态；在园区内，环境监测与能耗管理让运营更加高效低碳。智慧空间不是遥远的概念，而是正在发生的日常。</p>
      <p>让空间拥有智慧，归根结底是让技术回归于人，让生活更有温度。</p>
    `,
    category: 3,
    cover: require('@/assets/images/news/3.png'),
    editTime: '2025-06-02'
  },
  {
    _id: 'news2',
    title: '智慧园林管养解决方案：科技赋能，让城市更绿',
    content: `
      <p>智慧园林管养是一个综合性的概念，它集成人工智能（AI）、物联网（IoT）、基于大数据的人工智能等先进技术，实现对园林植物、设备、环境等的全面监测、通过大数据分析和机器学习算法，对收集到的数据进行深入挖掘和分析,并精准的给出决策支持与优化。</p>
      <h2>方案架构：一网一平台N应用</h2>
      <p><strong>感知网络</strong>：在绿地现场部署土壤墒情、气象环境、水质水位、视频监控等物联网设备，构建覆盖"植物-环境-设备"的全要素感知网络，数据实时回传。</p>
      <p><strong>管养平台</strong>：智慧园林管养平台汇聚全域数据，形成绿地资产一张图、养护工单一条链、考核评价一本账，支撑管理部门与养护企业的协同作业。</p>
      <p><strong>N个应用</strong>：面向不同场景提供精准灌溉、智能照明、病虫害预警、古树名木保护、游客服务等应用模块，按需组合、灵活扩展。</p>
      <h2>核心价值</h2>
      <p>通过智慧化手段，绿地养护可实现节水30%以上、人工成本降低20%以上，问题发现与处置效率显著提升。科技赋能之下，城市绿化正从"养得住"迈向"养得好"。</p>
    `,
    category: 3,
    cover: require('@/assets/images/news/2.png'),
    editTime: '2025-01-25'
  },
  {
    _id: 'news1',
    title: '科技赋能园林，智慧养护未来 | 景天下科技正式官宣！',
    content: `
      <p>景天下科技隶属于华伟控股集团旗下的景天下生态环境科技有限公司。集团自2009年创立于北京，以打造"地产全产业链综合平台"为战略核心，业务涵盖投资开发、工程建设、规划设计、非银金融四大板块，实力雄厚，资源广泛。母公司景天下生态是一家国家高新技术企业及"专精特新"企业，在生态景观、市政工程、生态修复及新基建领域拥有全方位的服务能力。这为景天下科技的持续创新与稳健发展提供了坚实保障。</p>
      <h2>我们的定位</h2>
      <p>景天下科技以"科技赋能园林"为使命，聚焦智慧园林软硬件产品的研发与智慧管养解决方案的落地，致力于成为园林行业数字化转型的最佳合作伙伴。</p>
      <h2>我们的业务</h2>
      <p>公司业务涵盖三大方向：一是<strong>智慧养护</strong>，包括智能灌溉、环境监测、病虫害预警等场景化产品；二是<strong>智慧空间</strong>，为公园、园区、社区提供一体化的空间智能化改造；三是<strong>智慧运营</strong>，依托数据平台帮助客户实现绿地资产的精细化、可视化管理。</p>
      <h2>我们的愿景</h2>
      <p>每一片绿地都值得被智慧地守护。景天下科技愿与行业同仁携手，用科技的力量让城市更绿、生活更美，共同书写智慧养护的未来篇章。</p>
    `,
    category: 1,
    cover: require('@/assets/images/news/1.jpg'),
    editTime: '2024-07-01'
  }
];

/**
 * 根据ID获取新闻详情
 * @param {String} id 新闻ID
 * @returns {Object|null} 新闻对象，未找到时返回 null
 */
export function getNewsById(id) {
  return newsItems.find(item => item._id === id) || null;
}

/**
 * 获取相关新闻推荐（同分类优先，排除当前文章）
 * @param {String} currentId 当前新闻ID
 * @param {Number} limit 推荐条数，默认3
 * @returns {Array} 推荐新闻列表
 */
export function getRelatedNews(currentId, limit = 3) {
  const current = getNewsById(currentId);
  if (!current) return newsItems.slice(0, limit);

  const sameCategory = newsItems.filter(
    item => item._id !== currentId && item.category === current.category
  );
  const others = newsItems.filter(
    item => item._id !== currentId && item.category !== current.category
  );

  return [...sameCategory, ...others].slice(0, limit);
}
